import React from 'react';
import arrowImg1728 from '../../../assets/arrow1728.svg';
import arrowImg1280 from '../../../assets/arrow1280.svg';
import { useMediaQuery } from '@mui/material';

function ECLandingSec1() {
    const isLargeScreen = useMediaQuery("(min-width:1728px)");
    return (
        <>
            <div className="flex flex-col gap-20 xl:gap-[175px] justify-center max-xs:px-5 max-xs:gap-8">
                <div className='flex flex-col gap-10 xl:gap-12'>
                    <span className="font-sans text-30 xl:text-40 font-semibold max-xs:text-center max-md:text-center max-lg:text-center">
                        Discover <span className='text-primary-200'>Creators.<br></br> Maximize ROI.</span> Go to Market.
                    </span>
                    <p className="font-sans text-base xl:text-xl font-normal xl:font-light leading-[30px] xl:leading-[40px] max-xs:text-center max-md:text-center max-lg:text-center">
                        Find your brand's untapped potential by leveraging the influence of over 500K+ geographically targeted creators. Amplify your ROI and achieve unrivalled market dominance. Start your first campaign INR 3000* Only.
                    </p>
                </div>
                <div className='flex justify-end max-lg:justify-center'>
                    <img src={isLargeScreen ? arrowImg1728 : arrowImg1280 } alt="ecLandingArrowImg" />
                </div>
            </div>
        </>
    )
}

export default ECLandingSec1
